import { AdditionalServiceProduct } from "@omni/types/api/product/bff/shared/additionalServiceProduct.model";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { AdditionalServiceComponent } from "@/components/Product/AdditionalService/additionalService.component";
import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { formatPriceForEcommerce } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/deliveryItem.base";

type Props = {
    className?: string;
};

export const Item = ({ className }: Props) => {
    const {
        montages,
        checked,
        serviceProductTooltipItem,
        activeServiceProducts,
        onChangeServiceProduct
    } = useDeliveryItemContext();

    const { index } = useMapped();

    const serviceProduct = montages[index];

    const onServiceProductClick = (serviceProduct: AdditionalServiceProduct) =>
        onChangeServiceProduct(serviceProduct);

    const isActiveProduct = checked
        ? activeServiceProducts?.includes(serviceProduct.sku)
        : false;

    return (
        <div className={cn("tw:flex tw:mt-2", className)}>
            <AdditionalServiceComponent
                additionalService={serviceProduct}
                tooltip={serviceProductTooltipItem}
                type={"checkbox"}
                isSelected={isActiveProduct}
                onClick={onServiceProductClick}
                documents={serviceProduct.documents}
            />
            <p
                className={cn(
                    "tw:font-bold tw:m-0 tw:text-right tw:whitespace-nowrap"
                )}
            >
                {serviceProduct.price &&
                    formatPriceForEcommerce(serviceProduct.price)}
            </p>
        </div>
    );
};
